<template>
  <div class="main">
    <!-- 标签 -->
    <ul
      class="tags-lines"
      v-if="ItemObject.studyType == 1"
    >
      <li
        class="tags-item"
        @click="tagsIndex = 1,fieldIndex=0"
        :class="{'tags-Active' : tagsIndex == 1}"
      ><span>实验简介</span></li>
      <li
        class="tags-item"
        @click="tagsIndex = 2,fieldIndex=0"
        :class="{'tags-Active' : tagsIndex == 2}"
      ><span>实验指导</span></li>
      <li
        class="tags-item"
        @click="tagsIndex = 3,fieldIndex=0"
        :class="{'tags-Active' : tagsIndex == 3}"
      ><span>实验操作</span></li>
      <!-- <li class="tags-item" @click="tagsIndex = 4,fieldIndex=0,getReport(1)" :class="{'tags-Active' : tagsIndex == 4}"><span>实验报告</span></li> -->
      <li
        class="tags-item"
        @click="tagsIndex = 4,fieldIndex=0,search()"
        :class="{'tags-Active' : tagsIndex == 4}"
      ><span>实验成绩</span></li>
    </ul>
    <div v-if="ItemObject.studyType == 1">
      <!-- 实验简介 -->
      <div
        class="exp-content"
        v-if="tagsIndex == 1"
      >
        <div class="exp-cont-left">
          <ul class="field-column">
            <li
              class="field-item"
              @click="fieldIndex = 0"
              :class="{'field-Active' : fieldIndex == 0}"
            >
              <span>实验视频简介</span>
            </li>
            <li
              class="field-item"
              @click="fieldIndex = 1"
              :class="{'field-Active' : fieldIndex == 1}"
            >
              <span>实验简介</span>
            </li>
            <li
              class="field-item"
              @click="fieldIndex = 2"
              :class="{'field-Active' : fieldIndex == 2}"
            >
              <span>实验原理</span>
            </li>
            <!-- <li class="field-item" @click="fieldIndex = 3" :class="{'field-Active' : fieldIndex == 3}">
              <span>实验结果与结论要求</span>
            </li> -->
            <li
              class="field-item"
              @click="fieldIndex = 4"
              :class="{'field-Active' : fieldIndex == 4}"
            >
              <span>网络条件要求</span>
            </li>
            <li
              class="field-item"
              @click="fieldIndex = 5"
              :class="{'field-Active' : fieldIndex == 5}"
            >
              <span>用户操作系统要求</span>
            </li>
          </ul>
        </div>
        <div class="exp-content-right">
          <div
            class="step"
            v-if="tagsIndex == 1"
          >
            <div
              class="step-item"
              v-if="fieldIndex == 0"
            >
              <div>
                <p class="part-title">实验视频简介</p>
                <video
                  v-if="ItemObject.experiment.brief_video"
                  style="width:570px;height:300px"
                  :src="ItemObject.experiment.brief_video"
                  controls="controls"
                ></video>
              </div>
            </div>
            <div
              class="step-item"
              v-if="fieldIndex == 1"
            >
              <div>
                <p class="part-title">实验简介</p>
                <div
                  class="part-content"
                  v-if="ItemObject.experiment.introduce"
                  v-html="ItemObject.experiment.introduce"
                ></div>
                <div
                  class="part-content"
                  v-else
                >
                  暂无内容，请进行维护
                </div>
              </div>
            </div>
            <div
              class="step-item"
              v-if="fieldIndex == 2"
            >
              <div>
                <p class="part-title">实验原理</p>
                <div
                  class="part-content"
                  v-if="ItemObject.experiment.theory_content"
                  v-html="ItemObject.experiment.theory_content"
                ></div>
                <div
                  class="part-content"
                  v-else
                >
                  暂无内容，请进行维护
                </div>
              </div>
            </div>
            <!-- <div class="step-item" v-if="fieldIndex == 3">
              <div>
                <p class="part-title">实验结果与结论要求</p>
                <div class="part-content" v-else>
                  暂无内容，请进行维护
                </div>
              </div>
            </div> -->
            <div
              class="step-item"
              v-if="fieldIndex == 4"
            >
              <div>
                <p class="part-title">网络条件要求</p>
                <div
                  class="part-content"
                  v-if="ItemObject.experiment.net_claim_content"
                >
                  说明客户端到服务器的带宽要求（需提供测试带宽服务）：{{ItemObject.experiment.net_claim_content}}
                  说明能够支持的同时在线人数（需提供在线排队提示服务）：{{ItemObject.experiment.net_claim_count}}
                </div>
                <div
                  class="part-content"
                  v-else
                >
                  说明客户端到服务器的带宽要求（需提供测试带宽服务）：<br>
                  暂无内容<br>
                  说明能够支持的同时在线人数（需提供在线排队提示服务）：<br>
                  暂无内容
                </div>
              </div>
            </div>
            <div
              class="step-item"
              v-if="fieldIndex == 5"
            >
              <div>
                <p class="part-title">用户操作系统要求（如Windows、Unix、IOS、Android等）</p>
                <div
                  class="part-content"
                >
                  <template v-if="ItemObject.experiment.sys_claim_computer">
                    计算机操作系统和版本要求：<br>
                    <span v-html="ItemObject.experiment.sys_claim_computer"></span><br>
                    其他计算终端操作系统和版本要求：<br>
                    <span v-html="ItemObject.experiment.sys_claim_other"></span><br>
                    支持移动端：<br>
                    {{ItemObject.experiment.sys_claim_mobile?'是':'否'}}<br>
                  </template>
                  <template v-else>
                    计算机操作系统和版本要求：<br>
                    暂无内容<br>
                    其他计算终端操作系统和版本要求：<br>
                    暂无内容<br>
                    支持移动端：<br>
                    否<br>
                  </template>
                  非操作系统软件要求:<br>
                  <template  v-if="ItemObject.experiment.not_sys_claim_soft">
                    <span v-for="(item,index) in JSON.parse(ItemObject.experiment.not_sys_claim_soft)" :key="index" style="margin-right: 10px;">
                      {{item}}
                    </span>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 实验简介 -->
      <div
        class="exp-content"
        v-if="tagsIndex == 2"
      >
        <div class="exp-cont-left">
          <ul class="field-column">
            <li
              class="field-item"
              @click="fieldIndex = 0"
              :class="{'field-Active' : fieldIndex == 0}"
            >
              <span>实验步骤</span>
            </li>
            <!-- <li class="field-item" @click="fieldIndex = 1" :class="{'field-Active' : fieldIndex == 0}">
              <span>实验讲解</span>
            </li> -->
          </ul>
        </div>
        <div class="exp-content-right">
          <div
            class="step"
            v-if="tagsIndex == 2"
          >
            <div
              class="step-item"
              v-if="fieldIndex == 0"
            >
              <div>
                <p class="part-title">实验方法与步骤要求</p>
                <div
                  class="part-content"
                >
                  <div class="content-text">共{{JSON.parse(ItemObject.experiment.step_claim_step).length?JSON.parse(ItemObject.experiment.step_claim_step).length:'--'}}步</div>
                  <div class="clearfix"></div>
                  <div class="content-text-table">
                    <table class="part-new-table">
                      <tbody>
                      <tr class="l_header">
                        <th>序号</th>
                        <th>
                          <p>步骤名称</p>
                        </th>
                        <th>
                          <p>步骤目标要求</p>
                        </th>
                        <th>
                          <p>步骤合理用时</p>
                        </th>
                        <th>
                          <p>目标达成度赋分模型</p>
                        </th>
                        <th>步骤满分</th>
                        <th>成绩类型</th>
                      </tr>

                      <tr
                        v-for="(item,index) in JSON.parse(ItemObject.experiment.step_claim_step)"
                        :key="index"
                      >
                        <td>{{index+1}}</td>
                        <td>{{item.name}}</td>
                        <td>{{item.target}}</td>
                        <td>{{item.useTime}}</td>
                        <td>{{item.model}}</td>
                        <td>{{item.score}}</td>
                        <td><label class="check-label check-label-block"><input
                          type="checkbox"
                          disabled=""
                          v-model="item.scoreType"
                          value="1"
                        >预习成绩</label><label class="check-label check-label-block"><input
                          type="checkbox"
                          disabled=""
                          v-model="item.scoreType"
                          value="2"
                        >操作成绩</label><label class="check-label check-label-block"><input
                          type="checkbox"
                          disabled=""
                          checked=""
                          v-model="item.scoreType"
                          value="3"
                        >实验报告</label><label class="check-label check-label-block"><input
                          type="checkbox"
                          disabled=""
                          v-model="item.scoreType"
                          value="4"
                        >教师评价报告</label></td>
                      </tr>

                      </tbody>
                    </table>
                  </div>
                  <div class="clearfix"></div><span class="content-title">（2）交互性步骤详细说明：</span>
                  <div class="clearfix"></div>
                  <div
                    class="content-text no-float"
                    v-if="!ItemObject.experiment.step_claim_step_des"
                  >暂无内容</div>
                  <div
                    class="content-text no-float"
                    v-if="ItemObject.experiment.step_claim_step_des"
                    v-html="ItemObject.experiment.step_claim_step_des"
                  >暂无内容</div>
                </div>
              </div>
            </div>
            <!-- <div class="step-item" v-if="fieldIndex == 1">
              <div>
                <p class="part-title">实验讲解</p>
                <div class="part-content">
                  暂无内容，请进行维护
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <!-- 实验操作 -->
      <div
        class="exp-content"
        v-if="tagsIndex == 3"
      >
        <div class="exp-cont-left">
          <ul class="field-column">
            <li
              class="field-item"
              @click="fieldIndex = 0"
              :class="{'field-Active' : fieldIndex == 0}"
            >
              <span>实验引导视频</span>
            </li>
            <!-- <li class="field-item" @click="fieldIndex = 1" :class="{'field-Active' : fieldIndex == 1}">
              <span>插件安装说明</span>
            </li> -->
            <li
              class="field-item"
              @click="fieldIndex = 2"
              :class="{'field-Active' : fieldIndex == 2}"
            >
              <span>我要实验</span>
            </li>
          </ul>
        </div>
        <div class="exp-content-right">
          <div
            class="step"
            v-if="tagsIndex == 3"
          >
            <div
              class="step-item"
              v-if="fieldIndex == 0"
            >
              <div>
                <p class="part-title">实验引导视频</p>
                <video
                  v-if="ItemObject.experiment.tech_video"
                  style="width:570px;height:300px"
                  :src="ItemObject.experiment.tech_video"
                  controls="controls"
                ></video>
              </div>
            </div>
            <!-- <div class="step-item" v-if="fieldIndex == 1">
              <div>
                <p class="part-title">插件安装说明</p>
                <div class="part-content">
                  暂无内容，请进行维护
                </div>
              </div>
            </div> -->
            <div
              class="step-item"
              v-if="fieldIndex == 2"
            >
              <div>
                <p class="part-title">开始实验</p>
                <div class="part-content">
                  <div class="content-title">
                    <img
                      src="@/assets/images/online/project-default.png"
                      alt=""
                    >
                    <span @click="doExperiment">我要实验</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 实验报告 -->
      <!-- <div class="exp-content" v-if="tagsIndex == 4">
        <div class="exp-content-right">
          <div>
            <p class="part-title">实验报告</p>
            <div class="part-content">
              <div>
                我的实验报告<br>
                <a v-if="Report.name" target="_blank" style="color:#337ab7;margin-top:20px" :href="Report.path">{{Report.name}}</a>
                <a v-else>暂无报告</a>
              </div>
              <span class="btn-primary" @click="showFileWindow">{{Report.name?'重新上传实验报告':'上传实验报告'}}</span>
            </div>
          </div>
        </div>
      </div> -->
      <div
        class="exp-content"
        v-if="tagsIndex == 4"
      >
        <div class="exp-content-right">
          <div>
            <p class="part-title">实验成绩</p>
            <div id="list">
              <table>
                <tbody>
                  <tr class="l_header">
                    <th class="itemStatus">姓名</th>
                    <th class="itemStatus">实验结果</th>
                    <th class="itemStatus">实验成绩</th>
                    <th class="itemStatus">实验开始时间</th>
                    <th class="itemStatus">实验结束时间</th>
                    <th class="itemStatus">实验用时</th>
                    <th
                      class="action"
                      width="130"
                    >操作
                    </th>
                  </tr>
                  <tr
                    class="item"
                    v-for="(item, index) in tableData"
                    :key="index"
                  >
                    <td>{{item.experimentStudent.userprofile.name}}</td>
                    <td>{{ item.status ? '完成' : '未完成' }}</td>
                    <td>{{ item.score }}</td>
                    <td>{{ item.startTime.replace('T', ' ') }}</td>
                    <td>{{ item.endTime.replace('T', ' ') }}</td>
                    <td>{{ item.timeUsed }}</td>
                    <td>
                      <a
                        class="edit"
                        href="javascript:;"
                        @click="viewDetail(item)"
                      >查看详情</a>
                      <br>
                      <a
                        v-if="item.reportStatus == 1"
                        class="edit"
                        href="javascript:;"
                        @click="downloadReport(item)"
                      >下载报告</a>
                      <a
                        v-if="item.reportStatus != 1"
                        class="edit"
                        style="color: #aaaaaa"
                        href="javascript:;"
                      >下载报告</a>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div
                class="noitems"
                v-if="tableData.length == 0"
              >没有数据</div>
            </div>
            <!-- 分页 -->
            <pagination
              :cur='pageInfo.page'
              :all='pageInfo.all'
              :totalData="pageInfo.totalData"
              :callback="pageCallback"
            ></pagination>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="theory"
    >
      <div v-if="Funsuffix(ItemObject.path) == 1">
        <video
          style="width:100%;height:500px"
          :src="ItemObject.path"
          controls="controls"
        ></video>
      </div>
      <div v-if="Funsuffix(ItemObject.path) == 2">
        <video
          style="width:100%;height:100px"
          :src="ItemObject.path"
          controls="controls"
        ></video>
      </div>
      <div v-if="Funsuffix(ItemObject.path) == 3">
        <img
          style="max-width:750px"
          :src="ItemObject.path"
          alt=""
        >
      </div>
      <div v-if="Funsuffix(ItemObject.path) == 4">
        <div class="pdf-region">
          <pdf
            :page="pageNum"
            :src="ItemObject.path"
            @progress="loadedRatio = $event"
            @num-pages="pageTotalNum=$event"
          ></pdf>
        </div>
        <div class="pagecolor">
          <span @click="prePage">上一页 </span> {{ pageNum }} / {{ pageTotalNum }} <span @click="nextPage"> 下一页</span>
        </div>
      </div>
      <div v-show="Funsuffix(ItemObject.path) == 5">
        <div
          ref="file"
          class="my-docx"
        ></div>
      </div>
    </div>
    <!-- 上传文件 -->
    <div
      id="file-upload-overlay"
      :style="showWindow.bigFile ? 'display: block' : ''"
    >
      <div class="file-upload-bg"></div>
      <div class="file-upload">
        <div class="file-upload-type">允许上传的文件扩展名：jpg,gif,png,mp4,doc,docx,xls,xlsx,ppt,pptx,pdf</div>
        <div
          class="file-upload-close"
          @click="hideFileWindow"
        >×</div>
        <span
          class="file_uploadBtn"
          id="file_uploadBtn"
          style="display: block;"
        >
          选择文件<input
            type="file"
            id="file_fileInput"
            ref="docFile"
            style="display: block;"
            @change="fileChange"
          >
        </span>
        <div
          class="fileBox"
          id="file_uploadBox"
          style="display: block;"
        >
          <span
            class="pauseBtn"
            id="file_pauseBtn"
            style="display: none;"
          >暂停</span>
          <span
            class="goBtn"
            id="file_goBtn"
            style="display:none;"
          >继续</span>
          <div
            class="filename"
            id="file_filename"
            style="display: none;"
          ></div>
          <div
            class="pbar"
            :style="showWindow.bigFileOption.showProgress ? 'display: block' : 'display: none'"
          >
            <div
              class="progress"
              id="file_progress"
              :style="'width: ' + Math.ceil(showWindow.bigFileOption.progressValue * 4.2) + 'px;'"
            ></div>
            <div id="file_percent">{{ showWindow.bigFileOption.progressValue }}%</div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <div
      class="form_overlay"
      :style="classShowDetailWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel form_panel_item">
        <div class="form_title">详情
          <span @click="classShowDetailWindow={}">X</span>
        </div>
        <div class="form_content">
          <div class="experiment_text">
            <p>实验名称：{{ formInfo.title }}</p>
            <p><span>实验开始时间：{{ experimentGrade.startTime }}</span>
              <span>实验结束时间：{{ experimentGrade.endTime }}</span>
              <span>实验用时：{{ experimentGrade.timeUsed }}</span>
            </p>
            <p><span>实验满分：100</span>
              <span>实验得分：{{ experimentGrade.score }}</span>
              <span>实验结果：{{ experimentGrade.status ? '完成' : '未完成' }}</span>
            </p>
          </div>
          <div class="f_list">
            <table v-if="tableStepData.length">
              <tbody>
                <tr class="l_header">
                  <th class="itemStatus">步骤名称</th>
                  <th class="itemStatus">步骤开始时间</th>
                  <th class="itemStatus">步骤结束时间</th>
                  <th class="itemStatus">步骤用时(秒)</th>
                  <th class="itemStatus">步骤合理用时(秒)</th>
                  <th class="itemStatus">步骤满分</th>
                  <th class="itemStatus">步骤得分</th>
                  <th class="itemStatus">步骤操作次数</th>
                  <th class="itemStatus">步骤评价</th>
                  <th class="itemStatus">赋分模型</th>
                  <th class="itemStatus">备注</th>
                </tr>
                <tr
                  class=""
                  v-for="item in tableStepData"
                  :key="item.id"
                >
                  <td class="itemStatus">{{ item.title }}</td>
                  <td class="itemStatus">{{ item.startTime.replace('T', ' ') }}</td>
                  <td class="itemStatus">{{ item.endTime.replace('T', ' ') }}</td>
                  <td class="itemStatus">{{ item.timeUsed }}</td>
                  <td class="itemStatus">{{ item.expectTime }}</td>
                  <td class="itemStatus">{{ item.maxScore }}</td>
                  <td class="itemStatus">{{ item.score }}</td>
                  <td class="itemStatus">{{ item.repeatCount }}</td>
                  <td class="itemStatus">{{ item.evaluation }}</td>
                  <td class="itemStatus">{{ item.scoringModel }}</td>
                  <td class="itemStatus">{{ item.remarks }}</td>
                </tr>
              </tbody>
            </table>
            <div
              class="noitems"
              v-else
            >没有数据
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import Pagination from '../Pager'
const docx = require('docx-preview')
window.JSZip = require('jszip')

export default {
  components: {
    pdf,
    Pagination
  },
  props: {
    ItemObject: Object
  },
  data() {
    return {
      tagsIndex: 1,
      fieldIndex: 0,
      showWindow: {
        bigFile: false,
        bigFileOption: {
          showProgress: false,
          progressValue: 0
        }
      },
      pageNum: 1,
      pageTotalNum: 1,
      loadedRatio: 0,
      Report: {
        name: '',
        path: ''
      },
      experimentReport: {
        name: '',
        path: ''
      },
      tableData: [],
      tableDataCount: 0,
      queryInfo: {
        page: 1,
        size: 10,
        experiment_id: '',
        userprofile_id: '',
        expJoinParam: 0,
        expJoinType: 11
      },
      classShowDetailWindow: {},
      tableStepData: [],
      experimentGrade: {},
      formInfo: {}
    }
  },
  mounted() {
    // if (this.Funsuffix(this.ItemObject.path) === 5) {
    //   this.$http.get(this.$store.state.rootUrl + this.ItemObject.path, {
    //     responseType: 'blob'
    //   }).then(({ data }) => {
    //     docx.renderAsync(data, this.$refs.file)
    //   })
    // }
    this.queryInfo.experiment_id = this.ItemObject.experiment_id
    this.queryInfo.userprofile_id = this.localUser.profile_id
  },
  watch: {
    ItemObject() {
      this.tagsIndex = 1
      this.queryInfo.experiment_id = this.ItemObject.experiment_id
      this.queryInfo.userprofile_id = this.localUser.profile_id
    }
  },
  computed: {
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    },
    localUser() {
      return this.$store.state.userInfo
    }
  },
  methods: {
    // 上一页
    prePage() {
      let page = this.pageNum
      page = page > 1 ? page - 1 : this.pageTotalNum
      this.pageNum = page
    },
    // 下一页
    nextPage() {
      let page = this.pageNum
      page = page < this.pageTotalNum ? page + 1 : 1
      this.pageNum = page
    },
    // 字符处理
    Character(path) {
      return path.split('/')[path.split('/').length - 1]
    },
    // 后缀名截取
    Funsuffix(path) {
      if (path) {
        var first = path.lastIndexOf('.')
        var namelength = path.length
        var filesuffix = path.substring(first + 1, namelength).toLowerCase()
        var index = 0

        if (filesuffix === 'mp4') {
          index = 1
        } else if (filesuffix === 'mp3') {
          index = 2
        } else if (filesuffix === 'jpg' || filesuffix === 'png') {
          index = 3
        } else if (filesuffix === 'pdf') {
          index = 4
        } else if (filesuffix === 'doc' || filesuffix === 'docx') {
          index = 5
          this.$http.get(this.$store.state.api + this.ItemObject.path, {
            responseType: 'blob',
            baseURL: ''
          }).then((data) => {
            docx.renderAsync(data, this.$refs.file)
          })
        }
      }
      return index
    },
    // 上传文件
    showFileWindow() {
      this.showWindow.bigFile = true
    },
    hideFileWindow() {
      this.showWindow.bigFile = false
    },
    // 上传文件
    async fileChange() {
      this.showWindow.bigFileOption.showProgress = true
      const fileRealName = this.$refs.docFile.files[0].name
      const uploadUrl = '/info_files/' + fileRealName
      await this.$http.put(uploadUrl, this.$refs.docFile.files[0], {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (e) => {
          this.showWindow.bigFileOption.progressValue = Math.ceil(e.loaded / e.total * 100)
        }
      }).then((data) => {
        this.experimentReport = {
          name: this.$refs.docFile.files[0].name,
          path: data
        }
        this.Report = {
          name: this.$refs.docFile.files[0].name,
          path: data
        }
        this.getReport(2)
        this.showWindow.bigFileOption.showProgress = false
        this.showWindow.bigFileOption.progressValue = 0
        this.hideFileWindow()
      }).catch(() => {
        this.showWindow.bigFileOption.showProgress = false
        this.showWindow.bigFileOption.progressValue = 0
        this.hideFileWindow()
        this.$layer.msg('上传失败！')
      })
    },
    // 做实验
    async doExperiment() {
      const onlineStudyId = this.ItemObject.id
      // const userProfileId = this.$store.state.userInfo.profile_id
      const userProfileId = this.$store.state.userInfo.profile_id

      await this.$http.get('/online_student_study_to_experiment/', {
        params: {
          userProfileId: userProfileId,
          onlineStudyId: onlineStudyId
        }
      }).then(async (data) => {
        if (data.code === '200') {
          if (data.url) {
            const fullUrl = data.url.toString().substr(0, 4).toLowerCase() === 'http' ? data.url : 'http://' + data.url
            if (data.url.indexOf('?') !== -1) {
              window.open(fullUrl + '&ticket=' + data.ticket + '&u=' + data.user_ticket)
            } else {
              window.open(fullUrl + '?ticket=' + data.ticket + '&u=' + data.user_ticket)
            }
          } else {
            this.$layer.msg('实验路径配置错误，请联系管理员！')
          }
        } else if (data.code === '400') {
          this.$layer.msg(data.msg)
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    // 查看实验报告
    async getReport(type) {
      var formInfo = {
        onlineStudent_id: this.$route.query.studentId,
        onlineStudy_id: this.ItemObject.id
      }
      await this.$http.get('/online_student_study/', {
        params: formInfo
      }).then((data) => {
        if (data.count && type === 1) {
          this.Report = JSON.parse(data.results[0].experimentReport)
        } else {
          this.Report = {
            name: '',
            path: ''
          }
        }
        if (type === 2) {
          if (!data.count) {
            this.SaveStudentStudy()
          } else {
            this.modifyStudentStudy(data.results[0].id)
          }
        }
      }).catch(() => {
        this.$layer.msg('获取列表信息失败！')
      })
    },
    // 设置已完成
    async SaveStudentStudy(studyId) {
      var formInfo = {
        onlineStudent_id: this.$route.query.studentId,
        onlineStudy_id: this.ItemObject.id,
        experimentReport: JSON.stringify(this.experimentReport),
        reportStatus: 1,
        percent: 100,
        status: 1
      }
      await this.$http.post('/online_student_study/', formInfo).then((data) => {
        this.getReport(1)
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('添加失败！')
      })
    },
    // 修改实验报告
    async modifyStudentStudy(id) {
      const url = '/online_student_study/' + id + '/'
      await this.$http.put(url, {
        experimentReport: JSON.stringify(this.experimentReport),
        reportStatus: 1
      }).then((data) => {
        this.getReport(1)
      }).catch((error) => {
        console.log(error)
      })
    },
    async search() {
      const onlineStudentStudyData = await this.$http.get('/online_student_study/', {
        params: {
          onlineStudent_id: this.$route.query.studentId,
          onlineStudy_id: this.ItemObject.id
        }
      })
      if (onlineStudentStudyData.results.length === 0) {
        this.tableData = []
        this.tableDataCount = 0
      } else {
        this.queryInfo.expJoinParam = onlineStudentStudyData.results[0].id
        await this.$http.get('/experimentgrade/', {
          params: this.queryInfo
        }).then((data) => {
          this.tableData = data.results
          this.tableDataCount = data.count
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    // 获取实验信息
    async getExperimentInfo() {
      const url = '/experiment/' + this.ItemObject.experiment_id + '/'
      await this.$http.get(url).then((data) => {
        this.formInfo = data
      }).catch((error) => {
        console.log(error)
      })
    },
    async viewDetail(item) {
      this.getExperimentInfo()
      item.startTime = item.startTime.replace('T', ' ')
      item.endTime = item.endTime.replace('T', ' ')
      this.experimentGrade = item
      this.classShowDetailWindow = {
        visibility: 'visible'
      }
      const params = {
        page: 1,
        size: 10000,
        experimentGrade_id: item.id
      }

      await this.$http.get('/experimentstep/', {
        params: params
      }).then((data) => {
        this.tableStepData = data.results
      }).catch(() => {
        this.$layer.msg('获取成绩信息失败！')
      })
    },
    downloadReport(item) {
      console.log(JSON.parse(item.experimentReport))
      window.open(JSON.parse(item.experimentReport).path)
    },
    pageCallback(data) {
      this.queryInfo.page = data
      this.search()
    }
  }
}
</script>
<style scoped src="@/assets/css/project-detail.css"></style>
<style scoped src="@/assets/css/table.css"></style>
<style scoped src="@/assets/css/chunkUpload.css"></style>
<style scoped src="@/assets/css/project-manage.css"></style>
<style lang="less" scoped>
//.part-new-table {
//  border: 1px solid #ebebeb;
//}
.part-new-table * {
  margin: 0;
  padding: 0;
}
.part-new-table td, .part-new-table th {
  border-right: 1px solid #ebebeb;
  border-bottom: 1px solid #ebebeb;
}
.my-docx {
  width: 100%;
  min-height: 500px;
}
.tags-lines {
  display: flex;
  height: 40px;
  background: #f1f1f1;
  .tags-item {
    text-align: center;
    width: calc(100% / 4);
    color: #333;
    cursor: pointer;
    span {
      line-height: 40px;
    }
  }
  .tags-Active {
    background: #73D6CA;
    color: #fff;
  }
}
.exp-content {
  overflow: hidden;
  display: flex;
  .exp-cont-left {
    width: 160px;
    .field-column {
      .field-item {
        display: block;
        text-align: center;
        background: #f9f9f9;
        height: 42px;
        line-height: 42px;
        border-radius: 22px;
        margin-top: 15px;
        cursor: pointer;
      }
      .field-Active {
        background: #73D6CA;
        color: #ffffff;
      }
    }
  }
  .exp-content-right {
    margin-left: 30px;
    flex: 1;
    margin-top: 15px;
    .part-title {
      font-size: 18px;
      margin-bottom: 10px;
      position: relative;
      padding: 0;
      &::before {
        content: "";
        height: 15px;
        width: 3px;
        position: absolute;
        top: 6px;
        left: -10px;
        background: #73D6CA;
      }
    }
    .part-content {
      border: 1px solid #f0f0f0;
      padding: 20px;
      color: #666666;
      min-height: 1rem;
      overflow: hidden;
      .content-title {
        display: flex;
        align-items: center;
        img {
          width: 260px;
          height: 152px;
        }
        span {
          cursor: pointer;
          display: inline-block;
          margin-left: 40px;
          width: 95px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          background: #73D6CA;
          color: #fff;
          border-radius: 4px;
          &:hover {
            text-decoration: underline;
          }
        }
      }
      .btn-primary {
        color: #fff;
        background-color: #337ab7;
        border-color: #2e6da4;
        display: inline-block;
        padding: 6px 12px;
        border-radius: 4px;
        margin-top: 30px;
        cursor: pointer;
      }
    }
  }
}
.theory {
  > div {
    > img {
      display: block;
      margin: 0 auto;
    }
  }
  .pdf-region {
    max-height: 460px;
    overflow-y: scroll;
  }
  .pagecolor {
    margin-top: 10px;
    margin-bottom: 20px;
    text-align: center;
    span:hover {
      color: #73D6CA;
      cursor: pointer;
    }
  }
}
#list td {
  padding: 2px;
  border-bottom: 1px solid #d6d6d6;
}
.form_title {
  position: relative;
  margin-bottom: 20px;
}

.form_title span {
  position: absolute;
  right: 0;
  top: 0;
  background: #ff8383 repeat scroll 0 0;
  color: #ff8383;
  cursor: pointer;
  height: 30px;
  line-height: 28px;
  text-align: center;
  width: 30px;
  font-size: 24px;
  border-radius: 3px;
  overflow: hidden;
}

.form_title span::before {
  content: "×";
  display: block;
  width: 30px;
  height: 30px;
  font-family: 宋体;
  color: rgb(255, 255, 255);
}

.experiment_text {
  margin-bottom: 20px;
}

.experiment_text p {
  line-height: 3;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.experiment_text p span {
  flex: 1;
}
.form_panel_item {
  max-width: 1300px;
  margin: 0;
  transform: translate(-50%, -50%);
}
</style>
